import { useState } from "react";

import { Button, IconName } from "@blueprintjs/core";
import { useMediaQuery } from "react-responsive";

import { isXsQuery } from "@/components/layout/Media";
import { ScenarioShareModal } from "@/components/pieces/roleplays/sharing/scenario-share/ScenarioShareModal";
import { FullScenario } from "@/types/roleplays";

const visibleBgStyle = {
  backgroundColor: "#0719560A",
  minWidth: "150px",
};

const SHARING_STATE_ICON: Record<string, IconName> = {
  "Only me": "eye-open",
  Workspace: "office",
  Shared: "people",
  Global: "globe-network",
};

export function ScenarioShareManager({ scenario }: { scenario: FullScenario }) {
  const [isOpen, setIsOpen] = useState(false);
  const isXs = useMediaQuery(isXsQuery);

  if (!scenario?.sharingStatus) {
    return null;
  }

  const style = { ...visibleBgStyle, marginRight: isXs ? "40px" : "5px" };

  return (
    <>
      <Button
        icon={SHARING_STATE_ICON[scenario.sharingStatus]}
        style={style}
        onClick={() => {
          setIsOpen(true);
        }}
        rightIcon="caret-down"
      >
        {scenario?.sharingStatus}
      </Button>

      <ScenarioShareModal
        scenario={scenario}
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        loading={false}
      />
    </>
  );
}
